import './Navbar.css';
import React, { useContext } from "react";

function Navbar(props) {
    return (
    <>
      <div className="Navbar-container">
          <a href={`/classes/863.23/EECS/people/Samuel/`} className="Navbar-link">Home</a>
          <div className="Navbar-link" onClick={() => props.setMenu(!props.menu)}>Weekly Assignments</div>
          <a href={`https://fab.cba.mit.edu/classes/863.23/EECS/people/Group/`} className="Navbar-link">Group Assignments</a>
          <div className="Navbar-link" onClick={() => props.setPage('final')}>Final Project</div>
      </div>
      <div className="Navbar-spacer"/>
    </>
  );
}

export const Navmenu =  [{id: "week1", label: "Week 1"}, 
                        {id: "week2", label: "Week 2"},
                        {id: "week3", label: "Week 3"},
                        {id: "week4", label: "Week 4"},
                        {id: "week5", label: "Week 5"},
                        {id: "week6", label: "Week 6"},
                        {id: 'week7', label: "Week 7"},
                        {id: 'week8', label: "Week 8"},
                        {id: 'week9', label: "Week 9"},
                        {id: 'week10', label: "Week 10"},
                        {id: 'week11', label: "Week 11"},
                        {id: 'week12', label: "Week 12"},
                        {id: 'week13', label: "Week 13"},
                        {id: 'week14', label: "Week 14"}
                      ];

export default Navbar;